module.exports = __webpack_public_path__ + "static/media/update_system.9d15800f.svg";